import { createApp } from 'vue';
import FreeAppView from '../../premium-report/GetReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-findmytalent-form-view')
Array.from(appElements).forEach(element => {
  createApp(FreeAppView).mount(element);
});

